import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import CustomInput from '../../../../components/CustomInput';
import Dropdown from '../../../../components/Dropdown';
import { Checkbox, ErrorText, RowView, Text, CustomDatePicker } from '../index';

const ControllingPerson = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  text_self_certification_dropdowns,
  errors,
  general_information_dropdowns,
}) => {
  const { TextWeight } = dynamicfunction();
  return (
    <>
      <RowView className='pt-3 sm:pt-5'>
        <Text
          text={getContent('controlling_persons_heading')}
          size={fontSizes.h22}
          isTruncate={false}
          weight={TextWeight.semiBold}
          className={'block'}
        />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('name_first')}
          value={values?.firstNameOfControllingPersons}
          onChange={(e) => {
            setFieldValue('firstNameOfControllingPersons', e.target.value);
            setFieldTouched('firstNameOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_name_first')}
          errorMessage={getContent(touched?.firstNameOfControllingPersons ? errors?.firstNameOfControllingPersons : '')}
        />
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('name_middle')}
          value={values?.middleNameOfControllingPersons}
          onChange={(e) => {
            setFieldValue('middleNameOfControllingPersons', e.target.value);
            setFieldTouched('middleNameOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_name_middle')}
          errorMessage={getContent(touched?.middleNameOfControllingPersons ? errors?.middleNameOfControllingPersons : '')}
        />
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('name_last')}
          value={values?.lastNameOfControllingPersons}
          onChange={(e) => {
            setFieldValue('lastNameOfControllingPersons', e.target.value);
            setFieldTouched('lastNameOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_name_last')}
          errorMessage={getContent(touched?.lastNameOfControllingPersons ? errors?.lastNameOfControllingPersons : '')}
        />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('current_residence_address')}
          value={values?.crsClassificationAddressOfControllingPerson}
          onChange={(e) => {
            setFieldValue('crsClassificationAddressOfControllingPerson', e.target.value);
            setFieldTouched('crsClassificationAddressOfControllingPerson', true, false);
          }}
          placeholder={getContent('placeholder_current_residence_address')}
          errorMessage={getContent(touched?.crsClassificationAddressOfControllingPerson ? errors?.crsClassificationAddressOfControllingPerson : '')}
        />
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('city')}
          value={values?.cityOfControllingPersons}
          onChange={(e) => {
            setFieldValue('cityOfControllingPersons', e.target.value);
            setFieldTouched('cityOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_city')}
          errorMessage={getContent(touched?.cityOfControllingPersons ? errors?.cityOfControllingPersons : '')}
        />
        <Dropdown
          isRounded
          isRequired={true}
          label={getContent('country')}
          value={values?.countryOfControllingPersons}
          onChange={(e) => {
            setFieldValue('countryOfControllingPersons', e.target.value);
            setFieldTouched('countryOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_country')}
          options={general_information_dropdowns?.countries}
          selectedValue={values?.countryOfControllingPersons}
          valueKey={'name'}
          isSearch
          onSelect={(val) => {
            setFieldValue('countryOfControllingPersons', val);
            setFieldTouched('countryOfControllingPersons', false);
          }}
          errorMessage={getContent(touched?.countryOfControllingPersons ? errors?.countryOfControllingPersons : '')}
        />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('district')}
          value={values?.districtOfControllingPersons}
          onChange={(e) => {
            setFieldValue('districtOfControllingPersons', e.target.value);
            setFieldTouched('districtOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_district')}
          errorMessage={getContent(touched?.districtOfControllingPersons ? errors?.districtOfControllingPersons : '')}
        />
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('building_number')}
          value={values?.buildingNumberOfControllingPersons}
          onChange={(e) => {
            setFieldValue('buildingNumberOfControllingPersons', e.target.value);
            setFieldTouched('buildingNumberOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_building_number')}
          errorMessage={getContent(touched?.buildingNumberOfControllingPersons ? errors?.buildingNumberOfControllingPersons : '')}
        />
        <CustomInput
          isRounded
          isRequired={true}
          label={getContent('street_name')}
          value={values?.streetNameOfControllingPersons}
          onChange={(e) => {
            setFieldValue('streetNameOfControllingPersons', e.target.value);
            setFieldTouched('streetNameOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_street_name')}
          errorMessage={getContent(touched?.streetNameOfControllingPersons ? errors?.streetNameOfControllingPersons : '')}
        />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
          <CustomInput
            label={getContent('mailing_address_if_different_current')}
            isRequired
            isRounded
            value={values?.mailingAddressOfControllingPersons}
            onChange={(e) => {
              setFieldValue('mailingAddressOfControllingPersons', e.target.value);
              setFieldTouched('mailingAddressOfControllingPersons', true, false);
            }}
            labelDivClass={"h-12 sm:h-6 md:h-9 lg:h-10 xl:h-9 2xl:h-6"}
            placeholder={getContent('placeholder_mailing_address_if_different_current')}
            errorMessage={getContent(touched?.mailingAddressOfControllingPersons ? errors?.mailingAddressOfControllingPersons : '')}
          />
            <CustomInput
              label={getContent('citizenship')}
              isRequired
              isRounded
              value={values?.crsClassificationNationalityOfControllingPerson}
              onChange={(e) => {
                setFieldValue('crsClassificationNationalityOfControllingPerson', e.target.value);
                setFieldTouched('crsClassificationNationalityOfControllingPerson', true, false);
              }}
              labelDivClass={"h-6 md:h-9 lg:h-10 xl:h-9 2xl:h-6"}
              placeholder={getContent('placeholder_citizenship')}
              errorMessage={getContent(
                touched?.crsClassificationNationalityOfControllingPerson ? errors?.crsClassificationNationalityOfControllingPerson : '',
              )}
            />
          <CustomDatePicker
            label={getContent('date_of_birth')}
            isRequired
            selectedDate={values?.crsClassificationDateOfBirth ? new Date(values?.crsClassificationDateOfBirth) : null}
            onChange={(val) => {
              setFieldValue('crsClassificationDateOfBirth', val ? val.toISOString().split('T')[0] : null);
              setFieldTouched('crsClassificationDateOfBirth', false);
            }}
            labelDivClass={"h-6 md:h-9 lg:h-10 xl:h-9 2xl:h-6"}
            maxDate={new Date()}
            errorMessage={getContent(touched?.crsClassificationDateOfBirth ? errors?.crsClassificationDateOfBirth : '')}
          />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          label={getContent('place_of_birth_city_country')}
          isRequired
          isRounded
          value={values?.crsClassificationPlaceOfBirth}
          onChange={(e) => {
            setFieldValue('crsClassificationPlaceOfBirth', e.target.value);
            setFieldTouched('crsClassificationPlaceOfBirth', true, false);
          }}
          labelDivClass={"h-8 md:h-9 lg:h-10 xl:h-6"}
          placeholder={getContent('placeholder_place_of_birth_city_country')}
          errorMessage={getContent(touched?.crsClassificationPlaceOfBirth ? errors?.crsClassificationPlaceOfBirth : '')}
        />
        <CustomInput
          label={getContent('tax_residency_country_or_jurisdiction')}
          isRequired
          isRounded
          value={values?.countryOfTaxResidenceOfControllingPersons}
          onChange={(e) => {
            setFieldValue('countryOfTaxResidenceOfControllingPersons', e.target.value);
            setFieldTouched('countryOfTaxResidenceOfControllingPersons', true, false);
          }}
          labelDivClass={"h-10 sm:h-6 md:h-9 lg:h-10 xl:h-6"}
          placeholder={getContent('placeholder_tax_residency_country_or_jurisdiction')}
          errorMessage={getContent(touched?.countryOfTaxResidenceOfControllingPersons ? errors?.countryOfTaxResidenceOfControllingPersons : '')}
        />
        <CustomInput
        label={getContent('controlling_person_ownership_percentage')}
          isRequired
          isRounded
          value={values?.crsClassificationPercentageOfOwnerShip}
          onChange={(e) => {
            setFieldValue('crsClassificationPercentageOfOwnerShip', e.target.value);
            setFieldTouched('crsClassificationPercentageOfOwnerShip', true, false);
          }}
          maxLength={3}
          labelDivClass={"h-10 sm:h-6 md:h-9 lg:h-10 xl:h-6"}
          placeholder={getContent('placeholder_controlling_person_ownership_percentage')}
          errorMessage={getContent(touched?.crsClassificationPercentageOfOwnerShip ? errors?.crsClassificationPercentageOfOwnerShip : '')}
        />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          label={getContent('zip_code')}
          value={values?.zipcodeOfControllingPersons}
          onChange={(e) => {
            setFieldValue('zipcodeOfControllingPersons', e.target.value);
            setFieldTouched('zipcodeOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_zipcode')}
          errorMessage={getContent(touched?.zipcodeOfControllingPersons ? errors?.zipcodeOfControllingPersons : '')}
          isRequired={true}
          maxLength={10}
        />
        <CustomInput
          label={getContent('additional_number')}
          value={values?.additionalNoOfControllingPersons}
          onChange={(e) => {
            setFieldValue('additionalNoOfControllingPersons', e.target.value);
            setFieldTouched('additionalNoOfControllingPersons', true, false);
          }}
          placeholder={getContent('placeholder_additional_number')}
          errorMessage={getContent(touched?.additionalNoOfControllingPersons ? errors?.additionalNoOfControllingPersons : '')}
          isRequired={true}
        />
        <div className='w-full' />
      </RowView>
      <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
        <CustomInput
          label={getContent('tin_or_its_functional_equivalent')}
          value={values?.tinForControllingPerson}
          onChange={(e) => {
            setFieldTouched('tinForControllingPerson', true, false);
            setFieldValue('unavailbleTINControllingPersonReasonId', []);
            setFieldValue('tinForControllingPerson', e.target.value);
          }}
          maxLength={15}
          labelDivClass={"h-18 md:h-9 lg:h-10 xl:h-6"}
          placeholder={getContent('tin_or_its_functional_equivalent')}
          errorMessage={getContent(touched?.tinForControllingPerson ? errors?.tinForControllingPerson : '')}
          isRequired={true}
        />
      </RowView>
      {
      values?.tinForControllingPerson?.trim()?.length > 0 
      ? null       
      : 
      <>
      <div className='pt-3 sm:pt-5'>
        <Checkbox
          label={getContent('tin_unavailability_reason')}
          value={values?.unavailbleTINControllingPersonReasonId}
          onChange={(option) => {
            const alreadySelected =
            values?.unavailbleTINControllingPersonReasonId?.[0]?.valueId === option?.id;

            if (alreadySelected) {
              setFieldValue('unavailbleTINControllingPersonReasonId', []);
            } else {
              setFieldValue('unavailbleTINControllingPersonReasonId', [
                { valueId: option?.id },
              ]);
            }
            setFieldTouched('unavailbleTINControllingPersonReasonId', false, false);
          }}
          options={text_self_certification_dropdowns?.dropDownFatcaTaxResidenceNoTin}
          isVertical
        />
        <ErrorText text={getContent(touched?.unavailbleTINControllingPersonReasonId ? errors?.unavailbleTINControllingPersonReasonId : '')} className='block'/>
      </div>
      {values?.unavailbleTINControllingPersonReasonId?.[0]?.valueId?.toString() === '1456' && (
        <RowView className='gap-7 pt-3 sm:pt-5' isResponsive>
          <CustomInput
            label={getContent('specify_please')}
            value={values?.reasonForTINUnavailableForControllingPerson}
            onChange={(e) => {
              setFieldValue('reasonForTINUnavailableForControllingPerson', e.target.value);
              setFieldTouched('reasonForTINUnavailableForControllingPerson', true, false);
            }}
            placeholder={getContent('specify_please')}
            errorMessage={getContent(touched?.reasonForTINUnavailableForControllingPerson ? errors?.reasonForTINUnavailableForControllingPerson : '')}
            isRequired={true}
          />
        </RowView>
      )}
      </>
      }

      <div className='pt-3 sm:pt-5'>
        <Checkbox
          label={getContent('controlling_person_status')}
          value={values?.controllingPersonStatusId}
          onChange={(option) => {
            const alreadySelected =
            values?.controllingPersonStatusId?.[0]?.valueId === option?.id;
            if (alreadySelected) {
              setFieldValue('controllingPersonStatusId', []);
            } else {
              setFieldValue('controllingPersonStatusId', [
                { valueId: option?.id },
              ]);
            }
            setFieldTouched('controllingPersonStatusId', false, true);
          }}
          options={text_self_certification_dropdowns?.dropDownControllingPersonStatus}
          isVertical
        />
        <ErrorText text={getContent(touched?.controllingPersonStatusId ? errors?.controllingPersonStatusId : '')} className='block'/>
      </div>
    </>
  );
};
export default ControllingPerson;
